import { relayStylePagination } from '@apollo/client/utilities';
import { InMemoryCache, ApolloLink, createHttpLink } from '@apollo/client/core';
import { ApolloOnErrorLink } from './errors-link';
import { ErrorHandler } from '@angular/core';
import { TimeoutError } from 'app/error-handler/custom-errors/timeout.error';
export function createApollo(graphqlUrl: string, middleware: ApolloLink, errorHandler: ErrorHandler, timeout: number): any {

    const cache = new InMemoryCache({
      addTypename: true,
      typePolicies: {
        Query: {
          fields: {
            companies: relayStylePagination(['category', 'accountType', 'accountStatus', 'search', 'lang', 'orderType', 'includeEmptyTranslations']),
            companiesInfo: relayStylePagination(['category', 'accountType', 'lang', 'materials', 'country', 'supplier', 'orderType']),
            randomCompaniesPage: relayStylePagination(['lang', 'category', 'seed']),
            randomProductsPage: relayStylePagination(['lang', 'category', 'seed']),
            esSearchByType: relayStylePagination(['lang', 'esType', 'esType', 'query']),
            news: relayStylePagination(['newsType', 'lang', 'newsStatus', 'unpublished', 'companyId', 'search', 'tag', 'fieldsOfRelevance', 'category'/* 'isAccessibleForFree' to check if needed */]),
            productsByCompany: relayStylePagination(['companyId', 'lang', 'category', 'adminMode']),
            filesList: relayStylePagination(['path', 'resourceType', 'search']),
            portalEvents: relayStylePagination(['fromDate', 'toDate', 'fieldOfRelevance', 'orderType']),
            companiesByAssociation: relayStylePagination(['associationId', 'lang']),
            companiesReviews: relayStylePagination(['lang']),
            requestsInfo: relayStylePagination(['lang', 'requestType', 'requestStatus']),
            requestInfoByCompanyId: relayStylePagination(['lang', 'recipientCompany']),
            followedCompaniesByUser: relayStylePagination(['userId', 'lang']),
            users: relayStylePagination(['userStatus', 'userRole', 'lang', 'search']),
            newsletters: relayStylePagination(['newsletterType', 'newsletterStatus', 'search']),
            usersCompanyVisitors: relayStylePagination(['lang', 'companyId', 'search','leadRelevance']),
            pageCategories: relayStylePagination(['level', 'lang', 'categoryId']),
            companiesVisitedByUser: relayStylePagination(['lang', 'userId']),
            wikis: relayStylePagination(['lang', 'wikiSector', 'wikiStatus']),
            allProductsPage: relayStylePagination(['lang', 'category']),
            savedProductsPage: relayStylePagination(['lang', 'userId']),
            usersPageVisitorsBySlug: relayStylePagination(['lang', 'search', 'page']),
          }
        },
        // FRAGMENT companyProducts DA RIVEDERE
        companyProducts: relayStylePagination(['category', 'lang', 'deletedMode']),
        FileInfo: {
          keyFields: ['public_id']
        },
        Folder: {
          keyFields: ['path']
        },
        UserProfile: {
          keyFields: [
            '_id', 'lang'
          ]
        },
        // UserCompany: {
        //   keyFields: ['company']
        // },
        Category: {
          fields: {
            childs: {
              merge(existing = [], incoming = []) {
                incoming = incoming || [];
                existing = existing || [];
                return incoming.length > existing.length ? [...incoming] : [...existing] ;
              }
            }
          }
        }
      }
    });
    //https://peyrone.medium.com/setting-a-custom-timeout-with-apollo-client-in-your-next-react-native-project-704dcc3c17fc
    function fetchWithTimeout(uri: string, options = {}, timeout: number): Promise<Response> {
      return new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
          reject(new TimeoutError('Request timed out', timeout, 408));
        }, timeout);
        fetch(uri, options).then(
          response => {
            clearTimeout(timer);
            resolve(response);
          },
          err => {
            clearTimeout(timer);
            reject(err);
          }
        );
      });
    }

    const errorLink = ApolloOnErrorLink(errorHandler);
    
    const _httpLink = createHttpLink({
      uri: graphqlUrl,
      fetch: (uri, options) => {
        return fetchWithTimeout(uri, options, timeout);
      }
    });
  
    return {
      link: ApolloLink.from([middleware, errorLink, _httpLink]),
      cache: cache,
      ssrMode: true,
    };
  }
